const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:3011' : '');

export function uploadUrl(url) {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${API_ORIGIN}${url}`;
}
